module.exports = __webpack_public_path__ + "static/tea-14d307b99c1cb1494c3d4cf652658daa.jpg";